import { initializeApp, getApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const getFirebaseConfig = () => {
  const configJson = process.env.REACT_APP_FIREBASE_CONFIG_JSON;
  if (configJson) {
    try {
      return JSON.parse(configJson);
    } catch (e) {
      console.error('Failed to parse REACT_APP_FIREBASE_CONFIG_JSON', e);
    }
  }

  // Fallback for local development (or if JSON parsing fails)
  // Create a .env.local file with these variables for local dev.
  return {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  };
};

const firebaseConfig = getFirebaseConfig();

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
export const auth = getAuth(app);
